import { render, staticRenderFns } from "./AppPc.vue?vue&type=template&id=1bfcea9c&scoped=true&"
import script from "./AppPc.vue?vue&type=script&lang=ts&"
export * from "./AppPc.vue?vue&type=script&lang=ts&"
import style0 from "./AppPc.vue?vue&type=style&index=0&id=1bfcea9c&prod&lang=css&"
import style1 from "./AppPc.vue?vue&type=style&index=1&id=1bfcea9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfcea9c",
  null
  
)

export default component.exports